var _radialGradient, _path, _radialGradient2, _path2, _linearGradient, _path3, _linearGradient2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8OpenEndWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "0BDJs3WtppMgo4Y9A7Ggja",
    cx: 9.169,
    cy: 38.67,
    r: 12.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#787f85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#7a8187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#90989f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#9da5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#a1aab3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0BDJs3WtppMgo4Y9A7Ggja)",
    d: "M19.915,21.8c-4.679,4.679-9.375,9.375-9.551,9.551l6.364,6.364 c0.177-0.177,4.872-4.872,9.551-9.551L19.915,21.8z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "0BDJs3WtppMgo4Y9A7Ggjb",
    cx: 13.425,
    cy: 35.499,
    r: 14.688,
    gradientTransform: "rotate(180 24.322 23.758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#787f85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#7a8187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#90989f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#9da5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#a1aab3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0BDJs3WtppMgo4Y9A7Ggjb)",
    d: "M24.728,29.715c4.679-4.679,9.375-9.375,9.551-9.551L27.915,13.8 c-0.177,0.177-4.872,4.872-9.551,9.551L24.728,29.715z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0BDJs3WtppMgo4Y9A7Ggjc",
    x1: 22.119,
    x2: 33.926,
    y1: -2552.883,
    y2: -2564.69,
    gradientTransform: "matrix(-1 0 0 1 39.046 2598.033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f979e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1aab3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0BDJs3WtppMgo4Y9A7Ggjc)",
    d: "M5.321,37.749c1.372-1.366,3.598-1.366,4.97,0c1.372,1.366,1.372,3.583,0,4.949 c-0.335,0.334-1.685,1.678-3.06,3.047c-0.33,0.328-0.183,0.902,0.269,1.013c1.114,0.273,2.314,0.33,3.561,0.096 c3.659-0.686,6.512-3.735,6.891-7.422c0.553-5.377-3.953-9.863-9.354-9.311c-3.703,0.379-6.764,3.22-7.453,6.862 c-0.235,1.242-0.178,2.435,0.096,3.545c0.111,0.451,0.688,0.597,1.017,0.268C3.637,39.427,4.986,38.082,5.321,37.749z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0BDJs3WtppMgo4Y9A7Ggjd",
    x1: 6.239,
    x2: 20.856,
    y1: -2588.237,
    y2: -2602.854,
    gradientTransform: "matrix(1 0 0 -1 23.614 -2580.535)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0BDJs3WtppMgo4Y9A7Ggjd)",
    d: "M40.662,13.312c-1.695,1.695-4.445,1.695-6.139,0s-1.695-4.445,0-6.139 c0.414-0.414,2.081-2.081,3.78-3.78c0.407-0.407,0.226-1.119-0.332-1.256c-1.377-0.338-2.858-0.409-4.399-0.119 c-4.519,0.852-8.043,4.633-8.512,9.207c-0.684,6.67,4.883,12.236,11.553,11.551c4.574-0.47,8.355-3.994,9.206-8.513 c0.29-1.541,0.219-3.021-0.119-4.398c-0.138-0.56-0.849-0.741-1.256-0.332C42.743,11.231,41.076,12.899,40.662,13.312z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8OpenEndWrench);
export default __webpack_public_path__ + "static/media/icons8-open-end-wrench.84821d57ff5a5e4d14b164df7e1697b4.svg";
export { ForwardRef as ReactComponent };